/**
 * Add this behavior to TokenInput view to allow for visual search ability
 * token = physical entry in search view
 * availableFields = list of things to search by that pops up when user types something in search
 * filters = actual search filters applied when searching
 */
define('fukit/behavior/fuzzy.search.behavior',['require','exports','module','underscore','backbone','marionette','../collection/base.collection','evicommon/state/param.adapter'],function(require, exports, module) {
  //prettier-ignore
  var _                  = require('underscore'),
      Backbone           = require('backbone'),
      Mn                 = require('marionette'),
      BaseCollection     = require('../collection/base.collection'),
      ParamAdapter       = require('evicommon/state/param.adapter');

  var FuzzySearchAdapter = ParamAdapter.extend({
    constructor: function(fuzzyRequestParams, options) {
      this.fuzzyRequestParams = fuzzyRequestParams;

      ParamAdapter.call(this, {}, options);
    },

    serializeModel: function() {
      var data = {
        fuzzy: this.fuzzyRequestParams ? this.fuzzyRequestParams.fuzzy : '',
        fuzzyFields: this.fuzzyRequestParams ? this.fuzzyRequestParams.fuzzyFields.toString() : [],
      };
      return data;
    },
  });

  var FuzzySearchBehavior = Mn.Behavior.extend({
    defaults: {
      // an array of fields to search by
      fuzzyFields: [],

      // collection of results
      searchResultCollection: new BaseCollection(),
    },

    initialize: function() {
      this.initializeSearchResultCollectionAndFilters();

      var self = this;
      this.fetchSearchResultCollection = _.debounce(function() {
        self._searchResultCollection.fetch();
      });

      this.fetchSearchResultCollection();
    },

    onChangeValue: function(view, text) {
      this.setFuzzyValue(text);

      this.fetchSearchResultCollection();
    },

    setFuzzyValue: function(value) {
      if (this.fuzzyRequestParams) {
        this.fuzzyRequestParams.fuzzy = value;
      }
    },

    initializeSearchResultCollectionAndFilters: function() {
      this._searchResultCollection = this.getOption('searchResultCollection') || new BaseCollection();

      this.fuzzyRequestParams = {
        fuzzy: '',
        fuzzyFields: this.getOption('fuzzyFields'),
      };

      this._searchResultCollection.addAdapter(new FuzzySearchAdapter(this.fuzzyRequestParams), {});
    },
  });
  module.exports = FuzzySearchBehavior;
});

